
import { Component, Injector, Input, OnInit } from '@angular/core';
import {
	ComponentContextService, DataFormBase, EventData, FormSchemaBase, TextControlSchema,
	SwitchControlSchema, DateTimeControlSchema
} from 'tnx-shared';
import { WorkflowService } from 'tnx-admin-service/workflowcore/workflow/services';

@Component({
	selector: 'workflow-form',
	templateUrl: './workflow-form.component.html',
	styleUrls: ['./workflow-form.component.scss'],
	providers: [ComponentContextService],
})
export class WorkflowFormComponent extends DataFormBase implements OnInit {

	constructor(
		protected _injector: Injector,
		private _workflowService: WorkflowService
	) {
		super(_injector);
	}

	ngOnInit() {
		super.ngOnInit();
		this.setting.baseService = this._workflowService;
		this.setting.schema = <FormSchemaBase[]>[
			new TextControlSchema({
				field: 'persistenceId',
				label: ''
			}),
			new DateTimeControlSchema({
				field: 'completeTime',
				label: ''
			}),
			new DateTimeControlSchema({
				field: 'createTime',
				label: ''
			}),
			new TextControlSchema({
				field: 'data',
				label: ''
			}),
			new TextControlSchema({
				field: 'description',
				label: ''
			}),
			new TextControlSchema({
				field: 'nextExecution',
				label: ''
			}),
			new TextControlSchema({
				field: 'status',
				label: ''
			}),
			new TextControlSchema({
				field: 'workflowDefinitionId',
				label: ''
			}),
			new TextControlSchema({
				field: 'reference',
				label: ''
			}),
			new TextControlSchema({
				field: 'stepMetadata',
				label: ''
			}),
			new TextControlSchema({
				field: 'code',
				label: ''
			}),
			new TextControlSchema({
				field: 'currentStateCode',
				label: ''
			})
		];
	}

	async onFormInitialized(formEvent: EventData) {
		// tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
	}

	async onFormEvent(evt) {
		// các event trong form
		console.log(evt);
	}

	async modifyDetailData(data) {
		// xử lý dữ liệu lấy từ get detail về
	}

	async onAfterGetDetail() {
		// xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
	}

	onBeforeSave() {
		// trước khi lưu
	}
}

